import { InjectableApi } from '../../shared/decorators';
import { Observable } from 'rxjs';
import { ApiResponse, GridApiResponse } from '../../entities/types';
import { GetComponentResponse } from '../../features/pages/document-review/types/document-details.type';
import { ApiService } from '../../shared/services';
import { TimelineEvent } from '../../features/pages/timeline-overview/types/timeline-overview.type';
import { DocumentErrors } from '../../features/pages/document-review/types/document.type';
import { AssetType } from '../types/asset-type.type';

@InjectableApi({
  baseSegment: 'ats/component',
})
export class ComponentService extends ApiService {
  getComponent(
    query: string,
    context?: string,
  ): Observable<ApiResponse<{ rows: GetComponentResponse[]; count: number }>> {
    return this.get(`${query}`, false, {}, undefined, context);
  }

  getAsset(
    query: string,
    context?: string,
  ): Observable<ApiResponse<{ rows: GetComponentResponse[]; count: number }>> {
    return this.get(`/ats/asset${query}`, true, {}, undefined, context);
  }

  // small, fixed reference list -- no pagination/filters, returned as a flat array
  getAssetTypes(context?: string): Observable<ApiResponse<AssetType[]>> {
    return this.get(`/ats/asset-type`, true, {}, undefined, context);
  }

  getComponentDetailsById(
    id: string,
  ): Observable<ApiResponse<GetComponentResponse>> {
    return this.get(`/${id}`);
  }

  getAssetById(
    id: string,
    context?: string,
  ): Observable<ApiResponse<GetComponentResponse>> {
    return this.get(`/ats/asset/${id}`, true, {}, undefined, context);
  }

  updateThrustRafting(id: string, payload: { thrustRating: string }) {
    return this.patch(`/${id}`, payload);
  }

  getTimelineEvents(
    componentId: string,
    context?: string,
  ): Observable<ApiResponse<TimelineEvent[]>> {
    return this.get(`/event/${componentId}`, false, {}, undefined, context);
  }

  getComponentById(id: string, templateId: string, context?: string) {
    return this.patch(`/${id}/template`, { templateId }, context);
  }

  getActiveTemplate(
    componentId: string,
    context?: string,
  ): Observable<
    ApiResponse<{
      activeTemplate: { id: string; componentId: string; templateId: string };
    }>
  > {
    return this.get(`/${componentId}/template`, false, {}, undefined, context);
  }

  getDocumentsErrorByComponentId(
    id: string,
    query: string,
    contextKey?: string,
  ): Observable<GridApiResponse<DocumentErrors[]>> {
    return this.get(`/${id}/errors${query}`, false, {}, undefined, contextKey);
  }
}
